import { createStyles, Theme } from '@zn-material-ui'

export default (theme: Theme) =>
  createStyles({
    itemHeight: {
      maxHeight: '300px',
    },
    selectContainer: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      height: '34px',
      marginBottom: '0px',
      minWidth: '68px',
      zIndex: 999,
    },
    select: {
      height: 'inherit',
      display: 'flex',
      alignItems: 'center',
      fontSize: '18px',
      color: theme.palette.text.primary,
      cursor: 'pointer',
      '& .icon': {
        top: 'calc(50% - 12px)',
        right: 0,
        color: '#363C46',
        position: 'absolute',
        pointerEvents: 'none',
      },
      '& .arrowIcon': {
        color: '#363C46',
        pointerEvents: 'none',
        position: 'absolute',
        right: '0px',
        cursor: 'pointer',
      },
      '& .selected': {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        width: '100%',
        '& p': {
          fontSize: '16px',
          color: '#999999',
          letterSpacing: 0,
        },
      },
    },
    menuItemName: {
      color: '#666',
      display: 'block',
      lineHeight: '18px',
      fontSize: '14px',
      marginLeft: '20px',
    },
    option: {
      width: '330px',
      maxHeight: '300px',
      overflowY: 'scroll',
      zIndex: 999,
      borderRadius: 3,
      borderRight: '1.6px solid rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      boxShadow: 'black 0px 0px 9px -5px',
      marginTop: 2,
      position: 'absolute',
      background: theme.palette.secondary.main,
      '& .selected': {
        background: '#FAFAFA',
      },
      '& .listItem': {
        height: 50,
        justifyContent: 'space-between',
        fontSize: '18px',
        color: '#333333',
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
        cursor: 'pointer',
        '&:hover': {
          background: '#FAFAFA',
        },
        '& .code': {
          color: '#999999',
          letterSpacing: 0.8,
          marginRight: 18,
        },
      },
    },
    hideBorder: {
      opacity: 0,
    },
    optionMask: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  })
